import { format } from 'date-fns'
export default {
    GET_ROOM_RESERVATIONS_SUCCESS: (state, data) => {
        data.results.forEach(reservation => {
            reservation.start = reservation.startDate
            reservation.end = reservation.endDate
            reservation.title = reservation.name
            reservation.resourceId = reservation.roomType.id
            reservation.textColor = 'white',
            reservation.backgroundColor = reservation.isBlocked ? '#E0E0E0':`#${reservation.roomType.colour}`
            if (reservation.createdBy.firstName && reservation.createdBy.lastName) {
                reservation.description = {'reservationName': reservation.name,
                    'reservationDate': `${format(new Date(reservation.startDate), 'HH:mm')} - ${format(new Date(reservation.endDate), 'HH:mm')}`,
                    'reservationCreatedBy': `${reservation.createdBy.firstName} ${reservation.createdBy.lastName}`,
                    'reservationStatus': `${reservation.roomReservationStatus.name}`}
            } else {
                reservation.description = {'reservationName': reservation.name,
                    'reservationDate': `${format(new Date(reservation.startDate), 'HH:mm')} - ${format(new Date(reservation.endDate), 'HH:mm')}`,
                    'reservationCreatedBy': `${reservation.createdBy.username}`,
                    'reservationStatus': `${reservation.roomReservationStatus.name}`}
            }
            reservation.borderColor = 'rgba(0, 0, 0, 0)'
            state.roomReservations.push(reservation)
        })
        state.roomReservations = data.results

    },
    GET_ROOM_RESERVATIONS_TYPES_SUCCESS: (state, data) => {
        state.roomReservationsTypes = data
    },
    GET_ROOM_RESERVATIONS_STATUSES_SUCCESS: (state, data) => {
        state.roomReservationsStatuses = data
    },
    CLEAR_ROOM_RESERVATIONS: state => {
        state.roomReservations = []
    },
}